const pluralize = (count, singular, plural) => {
  if (count > 1) return `${count} ${plural},`;
  if (count === 1) return `${count} ${singular},`;
  return '';
};
export default pluralize;
